module.exports = __webpack_public_path__ + "img/security-audit-img-4.3d80a70d.png";